import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=d72f6e84&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"
import style0 from "./Preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Preview.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Preview.vue
// module id = 1640
// module chunks = 1